import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=6a1716cf&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=6a1716cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1716cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1716cf')) {
      api.createRecord('6a1716cf', component.options)
    } else {
      api.reload('6a1716cf', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=6a1716cf&scoped=true", function () {
      api.rerender('6a1716cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/components/editor.vue"
export default component.exports